import { getThemeSettings, getLastUsedColorsFromFile } from "../assets/creator/themes";
import { defaultThemeName } from "../config/defaults";

const defaultSettings = getThemeSettings(defaultThemeName);

export function changeTheme(themeName, stepsChange = false) {
    const themeSettings = getThemeSettings(themeName);
    
    const newSettings = {
        ...this.state.colorSettings,
        ...defaultSettings,
        ...themeSettings
    }
    
    if (stepsChange !== true) {
        this.updateChangesArray({typeData: this.state.currentThemeName, counter: this.counter}, 1);
    }

    this.setState({currentThemeName: themeName});
    this.updateSettings(newSettings, true);

    if (!(localStorage.getItem('lastUsedColorsB2B'))) {
        localStorage.setItem('lastUsedColorsB2B', getLastUsedColorsFromFile(themeName));
    }

    localStorage.setItem(this.prefix + 'currentThemeName', JSON.stringify(themeName));
    localStorage.setItem(this.prefix + 'settings', JSON.stringify(themeSettings));
}